import { race, timer, throwError } from 'rxjs';
import { switchMapTo } from 'rxjs/operators';
import { retryBackoff } from 'backoff-rxjs';

const expireRequest = (timeout) => (source) => race(source, timer(timeout).pipe(switchMapTo(throwError({ message: 'Error: request timeout expired', status: 504 }))));

const httpRetryBackoff = (config) => {
    // parse the config argument
    const { initialIntervalMillis = 250, maxAttempts = 5, recoverable4xxCodes = [429], ignored5xxCodes = [], skipCors = false, } = typeof config === 'number' ? { initialIntervalMillis: config } : config;
    // convert our internal config into that which is expected by the library,
    // including our custom shouldRetry function
    const backoffConfig = {
        initialInterval: initialIntervalMillis,
        maxRetries: maxAttempts,
        shouldRetry: (err) => isRetryPossible(err, recoverable4xxCodes, ignored5xxCodes, skipCors),
    };
    return (source) => source.pipe(retryBackoff(backoffConfig));
};
const isRetryPossible = (error, recoverable4xxCodes, ignored5xxCodes, skipCors) => {
    const status = extractStatus(error);
    return (!isNaN(status) &&
        (is5xx(status, ignored5xxCodes) || isRecoverable4xx(status, recoverable4xxCodes) || (isCORS(status) && !skipCors)));
};
const extractStatus = (error) => {
    let ret = NaN;
    if (error && error.status !== undefined) {
        ret = parseInt(error.status, 10);
    }
    return ret;
};
const is5xx = (status, ignored5xxCodes) => status >= 500 && status <= 599 && ignored5xxCodes.indexOf(status) === -1;
const isRecoverable4xx = (status, recoverable4xxCodes) => recoverable4xxCodes.indexOf(status) > -1;
const isCORS = (status) => status === 0;

/**
 * Generated bundle index. Do not edit.
 */

export { expireRequest, httpRetryBackoff };
